export default {
    encoding: [
        {
            name: 'trend',
            type: '[number | string]',
            desc: 'Specify the dataSource applied to the single value.',
            defaultValue: 'primary[0]',
            isRequired: 'true',
        },
        {
            name: 'fill',
            type: '[string]',
            desc: `Specify the dataSource applied to the background color of the single value.
                   Note: This overrides any specified background color if backgroundColor is specified.`,
            isRequired: 'false',
        },
    ],
    events: [
        {
            name: 'value.click',
            desc: 'trigger when user clicks major value or icon',
        },
    ],
};
